import React from 'react'
import { Box, Flex, Divider, Text } from '@chakra-ui/react'
import OpenSourceProjectCard from './OpenSourceProjectCard'

const OpenSourceSection = () => {
  return (
      <Box
          w="85%"
          mt="10rem"
          mb="5rem"
          px="6.5rem"
      >
          <Flex
              justifyContent="flex-start"
              alignItems="center"
              mb="2.5rem"
              fontSize="1.5rem"
          >
              03.{" "}
              <Text
                  pl="0.5rem"
                  pr="1rem"
                  fontSize="1.75rem"
                  fontWeight="700"
                  color="text.light"
                  as={"span"}
              >
                  Open Source Contributions To
              </Text>
              <Divider w="40%" opacity="0.3" />
          </Flex>
          <Flex
            // justifyContent="space-between"
            mb="1.5rem"
            gridGap="1.5rem"
            wrap="wrap"
          >
              <OpenSourceProjectCard
                title="mui/material-ui"
                description="Quickly build beautiful React apps. MUI is a simple and customizable component library to build faster, beautiful, and more accessible React applications."
                githubLink="https://github.com/mui/material-ui"
                liveLink="https://mui.com/"
                tools={["React","Typescript","Javascript"]}
              />
              <OpenSourceProjectCard
                  title="fossasia/open-event-frontend"
                  description="The open source event solution for virtual and in-person events."
                  githubLink="https://github.com/fossasia/open-event-frontend"
                  liveLink="https://eventyay.com/"
                  tools={["Javascript", "Handlebars", "SCSS"]}
              />
              <OpenSourceProjectCard
                  title="cc-archive/cccatalog"
                  description="Identifies and collects data on cc-licensed content across web crawl data and public apis."
                  githubLink="https://github.com/cc-archive/cccatalog"
                  liveLink="https://github.com/WordPress/openverse-catalog"
                  tools={["Python", "HTML"]}
              />
              <OpenSourceProjectCard
                  title="zulip/zulip-mobile"
                  description="Zulip Mobile is the official mobile Zulip client, supporting both iOS and Android."
                  githubLink="https://github.com/zulip/zulip-mobile"
                  liveLink="https://play.google.com/store/apps/details?id=com.zulipmobile"
                  tools={["React Native", "Javascript"]}
              />
              <OpenSourceProjectCard
                  title="RocketChat/Rocket.Chat"
                  description="Rocket.Chat is an open-source fully customizable communications platform developed in JavaScript for organizations with high standards of data protection."
                  githubLink="https://github.com/RocketChat/Rocket.Chat"
                  liveLink="https://rocket.chat/"
                  tools={["React", "Javascript"]}
              />
          </Flex>
      </Box>
  )
}

export default OpenSourceSection